import type { PurchaseDetailsReview } from '@shared/domain/review';
import React from 'react';
import {

  ReviewStep,
} from '@shared/domain/review';
import { PURCHASE_DETAILS_FORM_FIELDS } from '../../data';
import { BaseReviewForm } from '../BaseReviewForm';

interface PurchaseDetailsReviewProps {
  submitReviewForm?: (
    formFields: PurchaseDetailsReview,
    reviewStep: ReviewStep,
    isDraft?: boolean,
  ) => void;
  editMode?: boolean;
  defaultValues?: Partial<PurchaseDetailsReview> & { id?: number };
  handleEditSuccess?: () => void;
}

function PurchaseDetailsReviewForm(props: PurchaseDetailsReviewProps) {
  return (
    <BaseReviewForm<PurchaseDetailsReview>
      reviewStep={ReviewStep.PURCHASE_DETAILS}
      formFields={PURCHASE_DETAILS_FORM_FIELDS}
      containerTestId="purchase-details-review-step-content-anchor"
      submitButtonText="Continue to Evaluation"
      editMode={props.editMode}
      defaultValues={props.defaultValues}
      onSubmit={props.submitReviewForm}
      onEditSuccess={props.handleEditSuccess}
    />
  );
}

export default PurchaseDetailsReviewForm;
